import React from 'react'
import { Link, useParams } from 'react-router-dom';
import './Work.scss'
import { images } from '../../constants'

const Work = () => {
  const workdata = [
    {id:'01', title:'MakeNTU KV', category:'GRAPHIC DESIGN', img:images.makentu},
    {id:'02', title:'Paintings', category:'PAINTING', img:images.matterhorn},
    {id:'03', title:'Culture ToGather', category:'UI/UX FRONTEND', img:images.culture},
    {id:'04', title:'NTUEE night KV', category:'GRAPHIC DESIGN', img:images.ntueenight},
  ]

  return (
    <div className='work-page' id='work'>
      <div className='work-page-title'>
        <h2>My Works</h2>
      </div>
      <ul className='second-part-work'>
          <hr/>
          { workdata.map((item)=> (
            <>
              <li key={item.id} style={{color:'var(--darkgray-color)'}} >
                <div className='second-part-work-id'>{item.id}</div>
                <div className='second-part-work-name'>
                  <h2>{item.title}</h2>
                  <p>{item.category}</p>
                </div>
                <div className='second-part-work-see'>
                  <img src={item.img} alt={item.id} />
                  <Link to={`/work/${item.id}`} className='see-more'>
                    <div className='see-more-circle'/>
                    <p>SEE PROJECT</p>
                    <i class="fas fa-sharp fa-solid fa-chevron-right"></i>
                  </Link>
                </div>
              </li>
              <hr/>
            </>
          )) }
        </ul>
    </div>
  )
}

export default Work